import { render, staticRenderFns } from "./homeContent.vue?vue&type=template&id=34f79d8a&scoped=true&"
import script from "./homeContent.vue?vue&type=script&lang=js&"
export * from "./homeContent.vue?vue&type=script&lang=js&"
import style0 from "./homeContent.vue?vue&type=style&index=0&id=34f79d8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f79d8a",
  null
  
)

export default component.exports